import React from 'react';

import {
	IsConductorClient,
	REBRANDING,
} from '~/config';

import AcceptInvitationWith2FAScreen from '~/components/app/AcceptInvitationWith2FAScreen';
import ConductorAuthenticationPage from '~/components/app/ConductorAuthenticationPage';
import KickstartPage from '~/components/app/KickstartPage';
import LoginScreen from './app/LoginScreen';
import NewLoginScreen from './app/NewLoginScreen';

import useUrlState from '~/hooks/useUrlState';



const UnauthenticatedSection: React.FC = () => {
	const urlState = useUrlState();

	if (IsConductorClient) {
		return (
			<div
				data-client-type="conductor"
				data-login-page="conductor"
				style={{ display: 'contents' }}
			>
				<ConductorAuthenticationPage />
			</div>
		);
	}

	if (urlState.name === 'acceptInvitationWith2FA') {
		return (
			<AcceptInvitationWith2FAScreen />
		);
	}

	if (urlState.name === 'kickstart') {
		return (
			<KickstartPage />
		);
	}

	if (REBRANDING?.loginPage === true) {
		return (
			<div
				data-client-type="contentking"
				data-login-page="new"
				data-rebranding-login="true"
				style={{ display: 'contents' }}
			>
				<NewLoginScreen />
			</div>
		);
	}

	return (
		<div
			data-client-type="contentking"
			data-login-page="old"
			data-rebranding-login="false"
			style={{ display: 'contents' }}
		>
			<LoginScreen />
		</div>
	);
};



export default UnauthenticatedSection;
